/**
 * This script handles scroll events
 */
import $ from "cash-dom";
import context from '../bg3d/context'

let $gamkeys;
let currKey;
let currentKeys = [];
let isNewPage = true;

export default class AnimationModule {

    static name = 'animation'

    constructor(node) {
        
        //init();
        readMaps();

        $(window).on('scroll', handleScrollInterpolate);
        handleScrollInterpolate();

        //link clicked
        window.document.addEventListener('gamLinkLoading', () => {
            //console.log('gamLinkLoading');

            //flag next mapMap
            isNewPage = true;

            $(window).off('scroll', handleScrollInterpolate);
        });

        //new html available
        window.document.addEventListener('gamLinkLoaded', () => {
            //console.log('gamLinkLoaded');
            readMaps();
            //give the browser 1s to scroll to target (scrollIntoView)
            window.setTimeout(handleScrollInterpolate, 1000);
        });

        //transition fully complete
        window.document.addEventListener('gamLinkComplete', () => {
            //console.log('gamLinkComplete');

            $(window).on('scroll', handleScrollInterpolate);
        });
    }
}

function readMaps() {

    $gamkeys = $('.gamkey');
    currentKeys = [];
    let lastData = {};

    $gamkeys.each(function() {

        const $this = $(this);
        const top = $this.offset().top;
        const data = $this.data();
        const dynData = Object.assign(lastData, data);

        //if a value is set to "reset", discard the previous value
        for(let key in dynData) {
            if( dynData[key] === 'reset') delete dynData[key];
        }

        currentKeys.push({
            node: $this,
            top: top,
            data: dynData
        });
        
        lastData = Object.assign({}, dynData);
    });

    if(window.pw.admin) {
        debugHelper();
    }

    //console.log('currentKeys', currentKeys);
}


function handleScrollInterpolate(e) {
    const y = window.pageYOffset;

    let above, below;
    const aboves = [], belows = [];

    for(let key of currentKeys) {

        //layouts may shift so we need to keep top values updated
        key.top = key.node.offset().top
        
        if(key.top - y <= 0) {
            aboves.push(key)
        } else {
            belows.push(key)
        }
    }

    if(aboves.length) {
        above = aboves.pop();
    } else {
        above = belows.shift();
    }
    if(belows.length) {
        below = belows.shift();
    }

    //console.log('scrolled above:', y, above.top, above.data.id);
    
    if(!above) return;

    //reached new map
    if(!currKey || (!above.node.is(currKey.node) && above.data.map !== currKey.data.map)) {
        //console.log('reached new map ...');
        gamEvent('gamMap', mapMap(above));
    }

    //get above pos+rot data
    const position = attr2arr(above.data.position);
    const rotation = attr2arr(above.data.rotation);
    //respect mobile z
    if(context.mqSmall.matches && above.data.mobilez) {
        position[2] = parseFloat(above.data.mobilez);
    }

    //if there is no key below, trigger the above max values
    if(!below) {
        gamEvent('gamKey', {
            position: position,
            rotation: rotation
        });
        return;
    }

    //interpolate between above and below
    const currScrollPos = Math.max(0, y - above.top);
    const currScrollDist = below.top - above.top;
    const normalisedDist = ((currScrollPos / currScrollDist) - 0.5) * 2; //linear
    const normalisedDistSin = (Math.sin((normalisedDist * Math.PI) / 2) + 1) / 2; //smooth

    //get below pos+rot data
    const position2 = attr2arr(below.data.position);
    const rotation2 = attr2arr(below.data.rotation);
    //respect mobile z
    if(context.mqSmall.matches && below.data.mobilez) {
        position2[2] = parseFloat(below.data.mobilez);
    }

    for(var i=0; i<3; i++) {
        position[i] += (position2[i] - position[i]) * normalisedDistSin;
    }
        
    for(var i=0; i<3; i++) {
        rotation[i] += (rotation2[i] - rotation[i]) * normalisedDistSin;
    }

    gamEvent('gamKey', {
        position: position,
        rotation: rotation
    });
}













/**
 * Fires a CustomEvent
 * @param {String} name 
 * @param {Object} data 
 */
export function gamEvent(name, data) {
    //console.log('gamEvent', name, data);
    var event = new CustomEvent(name, { detail: data });
    window.document.dispatchEvent(event);
}

/**
 * Convert a string like "0 -8 0" to an array like [0, -8, 0]
 * @param {String} str 
 */
function attr2arr(str) {

    if(!str) return [0,0,0];

    var arr = str.split(' ');
    //if(arr.length !== 3) return [0,0,0];

    for(var i=0; i<arr.length; i++) {
        arr[i] = parseFloat(arr[i]);
    }
    return arr;
}

    
function mapMap(currentKey) {

    //console.log('mapMap', currentKey);

    var attrs = {
        map: 'str',
        poster: 'str',
        position: 'arr',
        rotation: 'arr',
        spin: 'arr',
        keepspin: 'bool',
        step: 'int',
        psize: 'flt',
        prange: 'arr',
        wiggle: 'flt',
        opacity: 'flt',
        clear: 'flt',
        color: 'str',
        wipe: 'arr',
        offset: 'arr',
        width: 'flt',
        height: 'flt',
        depth: 'flt',
        random: 'flt',
        mobilez: 'flt'
    }

    var data = {};

    for(var key in attrs) {
        var d = currentKey.data[key];
        if(d == undefined) continue;

        switch(attrs[key]) {
            case 'arr':
                data[key] = attr2arr(d);
                break;
            case 'flt':
                data[key] = parseFloat(d);
                break;
            case 'int':
                data[key] = parseInt(d);
                break;
            case 'bool':
                data[key] = d ? true : false;
                break;
            default:
                data[key] = d;
        }
    }

    //apend isNewPage flag for the first mapMap per page
    if(isNewPage) {
        data.isNewPage = true;
        isNewPage = false;
    }
    
    //assuming mapMap always executes handleMap
    currKey = currentKey;

    return data;
}

function debugHelper() {
    
    $gamkeys.each(function(i) {
        var $elem = $(this);
        /*if($elem.data('parent')) {
            var selector = $elem.data('parent');
            var $elem = $elem.parents(selector).first();
        }*/
        $elem
            .addClass('gam-debug')
            .css({
                cursor: 'pointer',
                borderTop: '1px solid white',
                paddingLeft: '0.5rem'
            })
            .on('click', function() {
                $(this).toggleClass('open');

                if($(this).hasClass('open')) {
                    $(this).parent().css('z-index', 1);
                } else {
                    $(this).parent().css('z-index', 0);
                }
            });

        var $info = $('<div class="gam-debug-toggle">gamkey ('+ $elem.data('id') +')</div>')
            .css({
                color: '#112e26',
                fontFamily: 'monospace',
                background: '#3eb998',
                borderRadius: '0 0 0.5rem 0.5rem',
                border: '1px solid white',
                borderTopWidth: 0,
                padding: '0.5rem',
                textAlign: 'left',
                zIndex: 9999
            })
            .appendTo($elem);
        $('<div>' + JSON.stringify($elem.data(), null, 2) + '</div>')
            .css({
                color: 'inherit',
                whiteSpace: 'pre-wrap',
                display: 'none'
            })
            .appendTo($info);
    });

    $(document).on('keydown', function(e) {
        if(e.keyCode === 71) {
            $('.gam-debug')
                .css({
                    borderTop: 'none'
                })
                .find('.gam-debug-toggle')
                .remove();
        }
    })
}